import { useState } from "react";
import { Box } from "@mui/material";
import {
  DataGrid,
  GridToolbar,
  ptBR,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export default function GridView(props) {
  const [density, setDensity] = useState("compact");
  const theme = createTheme(
    {
      palette: {
        primary: { main: "#ff5722" },
        mode: localStorage.getItem("darkMode") === "true" ? "dark" : "light",
      },
    },
    ptBR,
  );

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  };

  return (
    <Box
      sx={{
        padding: 1,
        pt: 0,
        boxSizing: "border-box",
        visibility: "visible",
        position: "absolute",
        height: props.screenHeight - 135,
        width: "calc(100% - 241px)", //tamanho do menu esquerdo
      }}
    >
      <ThemeProvider theme={theme}>
        <DataGrid
          sx={{ borderRadius: 0 }}
          rows={props.rows}
          columns={props.columns}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          components={{ Toolbar: CustomToolbar }}
          density={density}
          onDensityChange={(newDensity) => setDensity(newDensity)}
          slots={{
            toolbar: CustomToolbar,
          }}
          /* pagination={false} */
        />
      </ThemeProvider>
    </Box>
  );
}
